export enum PageType {
	MUSIC_PAGE_TYPE_ALBUM = "MUSIC_PAGE_TYPE_ALBUM",
	MUSIC_PAGE_TYPE_PLAYLIST = "MUSIC_PAGE_TYPE_PLAYLIST",
	MUSIC_VIDEO_TYPE_OMV = "MUSIC_VIDEO_TYPE_OMV",
}

export const FE_MUSIC_HOME = "FEmusic_home"
